import Address from './Address';

enum NotificationType {
  TOOLTIP_TUTORIAL = 'tooltip_tutorial',
  MENU_STATUS_MESSAGE = 'menu_status_message',
  ADDRESS_CHANGE = 'address_change',
  PLAN_CHANGE = 'plan_change',
  FAVORITES_ANNOUNCEMENT = 'favorites_announcement',
  LESS_PREP_ANNOUNCEMENT = 'less_prep_announcement',
}

interface IConfig {
  thanksgiven?: Record<string, unknown>;
}

interface INotification {
  id: number;
  notification_type: NotificationType;
  config?: IConfig;
}

interface IStatusMessageNotification extends INotification {
  message: string;
}

interface IAddressChangeNotification extends INotification {
  date: Date;
  address: Address;
  operation: 'ADD' | 'REMOVE' | 'UPDATE';
}

interface INotifications {
  notifications: INotification[];

  readonly statusMessages?: IStatusMessageNotification;
  readonly addressChange?: IAddressChangeNotification;
  readonly hasTooltipTutorial?: boolean;
  readonly hasFavoritesAnnouncement?: boolean;
}

class Notifications implements INotifications {
  notifications: INotification[];

  constructor(notifications?: INotification[]) {
    this.notifications = notifications || [];
  }

  get(type: NotificationType | string): INotification[] {
    return this.notifications.filter((item) => (
      item.notification_type === (type as NotificationType)
    ));
  }

  has(type: NotificationType | string): boolean {
    return this.notifications.some((item) => (
      item.notification_type === (type as NotificationType)
    ));
  }

  get statusMessages(): IStatusMessageNotification {
    return this.get(
      NotificationType.MENU_STATUS_MESSAGE,
    )[0] as IStatusMessageNotification;
  }

  get addressChange(): IAddressChangeNotification {
    return this.get(
      NotificationType.ADDRESS_CHANGE,
    )[0] as IAddressChangeNotification;
  }

  get planChange(): boolean {
    return this.has(NotificationType.PLAN_CHANGE);
  }

  get hasTutorialTooltip(): boolean {
    return this.has(NotificationType.TOOLTIP_TUTORIAL);
  }

  get hasFavoritesAnnouncement(): boolean {
    return this.has(NotificationType.FAVORITES_ANNOUNCEMENT);
  }

  get lessPrepAnnouncement(): INotification | null {
    return this.get(NotificationType.LESS_PREP_ANNOUNCEMENT)[0] as INotification;
  }
}

export type { INotification, INotifications };
export { NotificationType };
export default Notifications;
